import axios from "axios";

const VUE_APP_TOP_HAT_API_URL = process.env.VUE_APP_TOP_HAT_API_URL;

export async function fetchTopHatData() {
  const url = VUE_APP_TOP_HAT_API_URL;
  const headers = {
   'x-team': 'Credit Ratings'
  };
  const response = await axios.get(url, { headers });
  const topHatData = response?.data ?? [];
  const navContent =  topHatData?.nav_items?.map((drawer) => {
    const drawerItem =  drawer?.drawer_opener;
    return {
      id: drawerItem?._metadata?.uid || '',
      label: drawerItem?.drawer_opener_text || '',
      alignment: drawerItem?.large_viewport_title_justify || '',
      navItems: drawerItem?.drawer_columns?.map(column => {
          const columnKey = Object.keys(column)?.[0];
          const listData = column?.[columnKey];
          let transformedList;
          switch (columnKey) {
            case "taxonomy_list":
              transformedList = transformTaxonomyList(listData);
              break;
            case "custom_list":
              transformedList = transformCustomList(listData);
              break;
            case "link":
              transformedList =transformLinkList(listData);
              break;
          }
          return transformedList;
        }) 
    }
  });
  return {
      logo: "",
      mainLink: {
          label: "",
          href: ""
      },
      navSections: {
          drawerNav: navContent
      }
  };
}

const transformCustomList = function (customList) {
  return {
    id: customList?._metadata?.uid || '',
    label: customList?.column_name || '',
    navItems: customList?.links?.map( item => {
      const itemData =  item?.link;
      return {
        id: item?._metadata?.uid || '',
        label: itemData?.title || '',
        href: itemData?.href || '',
      }
    })
  }
}

const transformTaxonomyList = function (customList) {
  return {
    id: customList?._metadata?.uid || '',
    label: customList?.column_name_override || '',
    navItems: customList?.list?.flatMap( item => {
      const taxonomy = item?.global_field?.morningstar_taxonomy?.[0] || [];
      const taxonomyKey = Object.keys(taxonomy)?.[0];
      const brands = taxonomy?.[taxonomyKey]?.[taxonomyKey] || [];
      return brands?.map ( brand => {
        return {
          id: brand?.uid || '',
          label: brand?.title || '',
          href: brand?.url || '',
        }
      })
    })
  }
}

const transformLinkList = function (customList) {
  const itemData =  customList?.link;
  return {
    id: customList?._metadata?.uid || '',
    label: itemData?.title || '',
    href: itemData?.href || '',
  }
}

